<header class="header" [class.scrolled]="scrolled">
  <!-- Topbar: slim dark strip with welcome text, language & socials -->
  <div class="topbar">
    <div class="container">
      <div class="topbar-inner">
        <span class="topbar-welcome">
          {{'GB_Registration_MainHeaderBlueLineText' | translate}}
        </span>

        <div class="topbar-actions">
          <!-- Language selector -->
          <ul class="topbar-menu">
            <li>
              <a href="javascript:void(0)" [matMenuTriggerFor]="langMenu" class="lang-trigger">
                <span
                  class="flag-icon flag-icon-{{selectedLanguage.flag == 'en' ? 'gb' : selectedLanguage.flag}}"></span>
                <span class="lang-name">{{selectedLanguage.name | translate}}</span>
                <mat-icon class="lang-caret">expand_more</mat-icon>
              </a>

              <mat-menu #langMenu="matMenu" class="lang-dropdown">
                @for(lang of listLang; track lang) {
                <button type="button" mat-menu-item (click)="selectLanguage(lang)">
                  <span class="flag-icon flag-icon-{{lang.flag == 'en' ? 'gb' : lang.flag}} me-2"></span>
                  {{lang.name | translate}}
                </button>
                }
              </mat-menu>
            </li>
          </ul>

          <!-- Social icons -->
          <ul class="topbar-sosmed">
            <li>
              <a href="https://carteldamageclaims.com/" target="_blank" rel="noopener" title="Website">
                <i class="fa-solid fa-store"></i>
              </a>
            </li>
            <li>
              <a href="https://x.com/C_D_C_Brussels" target="_blank" rel="noopener" title="X / Twitter">
                <i class="fa-brands fa-x-twitter"></i>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/cartel-damage-claims-cdc-?originalSubdomain=be" target="_blank"
                rel="noopener" title="LinkedIn">
                <i class="fa-brands fa-linkedin-in"></i>
              </a>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>

  <!-- Main nav: logo + contact info + CTA -->
  <div class="navbar-main">
    <div class="container container-nav">
      <div class="nav-inner">

        <!-- Logo -->
        <a href="/" class="navbar-brand">
          <img src="/assets/images/cdc-logo.png" alt="CDC Logo" class="brand-logo" />
        </a>

        <!-- Contact snippets -->
        <div class="nav-contacts">
          <div class="contact-item">
            <span class="contact-icon">
              <i class="fa-solid fa-envelope-open-text"></i>
            </span>
            <div class="contact-text">
              <span class="contact-label">{{'GB_Registration_EmailSupport' | translate}}</span>
              <span class="contact-value">{{'GB_Registration_ContactEmail' | translate}}</span>
            </div>
          </div>

          <div class="contact-item">
            <span class="contact-icon">
              <i class="fa fa-phone"></i>
            </span>
            <div class="contact-text">
              <span class="contact-label">{{'GB_Registration_CallSupport' | translate}}</span>
              <span class="contact-value">{{'GB_Registration_ContactPhone' | translate}}</span>
            </div>
          </div>
        </div>

        <!-- CTA button -->
        <a [routerLink]="['/register']" class="btn-register">
          {{'GB_Registration_RegisterNow' | translate}}
        </a>

      </div>
    </div>
  </div>
</header>
